import { replace } from 'connected-react-router';

export function redirectToNotFound() {
    return redirectTo('/404');
}

export default function redirectTo(pathname: string) {
    return replace({ pathname });
}
